import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FlowwerInitializaterComponent } from '../../../../shared/components/flowwwer-initializater-component/flowwwer-initializater-component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LibraryService } from '../../../../core/services/library/library.service';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { ClinicQuery } from '../../../../shared/state/clinic/clinic.query';
import { CompanyService } from '../../../../shared/state/company/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../../../../shared/state/settings/settings.service';
import { ClinicDetailService } from '../../../../shared/state/clinic-detail/clinic-detail.service';
import { AlertController, ModalController, NavController, Platform } from '@ionic/angular';
import { UserService } from '../../../../shared/state/user/user.service';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { Observable } from 'rxjs';
import { UserEditModel } from '../../../../shared/models/userEdit.model';
import { KeyboardQuery } from '../../../../shared/state/keyboard/keyboard.query';
import { CompanyQuery } from '../../../../shared/state/company/company.query';
import { RouterService } from '../../../../core/services/router/router.service';
import {
    fade_in,
    fade_out,
    fade_out_absolute,
} from 'src/app/core/animations/fade';

@Component({
    selector: 'app-user-account-edit',
    animations: [fade_out, fade_in, fade_out_absolute],
    templateUrl: './user-account-edit.component.html',
    styleUrls: ['./user-account-edit.component.scss'],
})
export class UserAccountEditComponent
    extends FlowwerInitializaterComponent
    implements OnInit, OnDestroy {
    systemKeyUrl$: Observable<string>;
    clinicDetailId$: Observable<string>;
    isLoadingContent = false;

    editAccountForm: FormGroup;

    userPhoneForm;
    userEmailForm;
    keyboardIsShowing: Observable<boolean>;
    showClinicDetails$: Observable<boolean>;
    isUserAccountATab: boolean;
    isEnabledUserAccount: boolean;
    currentTab;

    /** flowwwer template */
    clinicName$: Observable<string>;
    clinicDetailRgpdDisable$: Observable<boolean>;
    userEnableRgpd: boolean;
    @Input() isModal = false;

    constructor(
        public formBuilder: FormBuilder,
        private keyboardQuery: KeyboardQuery,
        private companyQuery: CompanyQuery,
        private modalController: ModalController,
        private router: Router,
        private alertCtrl: AlertController,
        private platform: Platform,
        libraryService: LibraryService,
        clinicDetailQuery: ClinicDetailQuery,
        companyService: CompanyService,
        activatedRoute: ActivatedRoute,
        settingsService: SettingsService,
        clinicDetailService: ClinicDetailService,
        navCtrl: NavController,
        userService: UserService,
        settingsQuery: SettingsQuery,
        userQuery: UserQuery,
        routerService: RouterService
    ) {
        super(
            activatedRoute,
            settingsService,
            userService,
            companyService,
            clinicDetailService,
            navCtrl,
            clinicDetailQuery,
            settingsQuery,
            userQuery,
            libraryService,
            routerService
        );
    }

    async ngOnInit(): Promise<void> {
        this.currentTab = this.router.url.split('/')[3]?.split('?')[0];
        this.keyboardIsShowing = this.keyboardQuery.select('isShowing');
        this.systemKeyUrl$ = this.settingsQuery.select('systemKeyURL');
        this.clinicDetailId$ = this.clinicDetailQuery.select('id');
        this.isLoadingContent = true;

        // TODO ver si este valor del observable se rellena antes de que se use en la siguiente linea
        this.settingsQuery.selectIsUserAccountATab().subscribe((value) => {
            this.isUserAccountATab = value;
        });

        this.settingsQuery.selectIsEnabledUserAccount().subscribe((value) => {
            this.isEnabledUserAccount = value;
        });

        /**
         * Si lo vamos a abrir como modal, no inicializamos company, clinic etc
         */
        if (!this.isUserAccountATab || this.isModal) {
            this.user$ = this.userQuery.select();
            this.initForm();
        } else {
            /**
             * Llegar a este componente por ruta normal
             */
            try {
                await this.initializeCompanyClinicUser();
                this.initForm();
            } catch (error) {
                this.isLoadingContent = false;
                return;
            }

            /** Si entramos aquí por ruta pero no tenemos el tab de mi perfil, no podemos entrar a
             * /user-account-edit, tenemos que redirigir porque se entrará por modal */
            this.checkRedirectOnUserAccountModal();
        }

        /** TODO: CHAPUZA, metemos este timeout para quitar el skeleton de las tabs al cambiar de tab */
        setTimeout(() => {
            this.isLoadingContent = false;
        }, 200);

        this.showClinicDetails$ = this.settingsQuery.select(
            'showClinicDetails'
        );

        /** flowwwer template */
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
        this.clinicDetailRgpdDisable$ = this.clinicDetailQuery.select(
            'RGPDDisable'
        );
        this.userEnableRgpd = this.userQuery.enableRGPD;
    }

    initForm() {
        this.editAccountForm = this.formBuilder.group({
            userPhone: [
                this.userQuery.phone,
                [
                    Validators.required,
                    Validators.pattern(
                        '^([+]?[\\s0-9]+)?(\\d{3}|[(]?[0-9]+[)])?([-]?[\\s]?[0-9])+$'
                    ),
                ],
            ],
            userEmail: [
                this.userQuery.email,
                [
                    Validators.required,
                    Validators.pattern('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$'),
                ],
            ],
        });
    }

    get controls() {
        return this.editAccountForm.controls;
    }

    async submit() {
        if (this.editAccountForm.invalid) {
            Object.values(this.editAccountForm.controls).forEach((control) => {
                control.markAsTouched();
            });
            return;
        }

        const userRegister: UserEditModel = {
            tokenId: this.userQuery.tokenId,
            phone: this.editAccountForm.value.userPhone,
            email: this.editAccountForm.value.userEmail,
            enableRgpd: this.userEnableRgpd,
            points: this.userQuery.points,
        };
        /** Registramos el usuario y lo logeamos en el sistema */
        await this.userService.editUser(userRegister);

        if (!this.isUserAccountATab || this.isModal) {
            this.dismissModal();
        } else {
            this.navCtrl.navigateBack(
                '/' +
                    this.settingsQuery.systemKeyURL +
                    '/' +
                    this.clinicDetailQuery.id +
                    '/user-account'
            );
        }
    }

    dismissModal() {
        this.modalController.dismiss({
            dismissed: true,
        });
    }

    checkRedirectOnUserAccountModal() {
        /**
         * Programa amigo, no puedo entrar a estas páginas si van a funcionar como modals
         */
        if (!this.isUserAccountATab || !this.isEnabledUserAccount) {
            this.router.navigate([
                '/' +
                    this.settingsQuery.systemKeyURL +
                    '/' +
                    this.clinicDetailQuery.id +
                    '/details',
            ]);
        }
    }

    goToAccount() {
        this.router.navigate([
            '/',
            this.settingsQuery.systemKeyURL,
            this.clinicDetailQuery.id,
            'user-account',
        ]);
    }

    /** Al destruir el componente nos desuscribimos al observable de los parámetros de esta página */
    ngOnDestroy() {
        /**
         * Si lo vamos a abrir como modal, no inicializamos company, clinic etc
         */
        if (this.isUserAccountATab && !this.isModal) {
            this.unsuscribeParamsQueryParams();
        }
    }

    /** flowwwer template */
    goBack(): void {
        if (!this.isUserAccountATab || this.isModal) {
            this.dismissModal();
        } else {
            this.navCtrl.navigateBack(
                '/' +
                    this.settingsQuery.systemKeyURL +
                    '/' +
                    this.clinicDetailQuery.id +
                    '/user-account'
            );
        }
    }

    hasControlError(controlName: string): boolean {
        if (this.controls.hasOwnProperty(controlName)) {
            const control = this.controls[controlName];

            return control.invalid && control.touched;
        }

        return false;
    }

    async showConfirmDeleteClient() {
        const alert = await this.alertCtrl.create({
            mode: this.platform.is('android') ? 'md' : 'ios',
            message: this.libraryService.getLabel('lbl_con_delete_client'),
            buttons: [
                {
                    text: this.libraryService.getLabel(
                        'app_ask_sched_step_3_button'
                    ),
                    role: 'confirm',
                    handler: () => {
                        this.deleteClient();
                    },
                },
                {
                    text: this.libraryService.getLabel('app_action_cancel'),
                    role: 'cancel',
                },
            ],
        });
        await alert.present();
    }

    async deleteClient() {
        await this.userService.deleteClient(this.userQuery.tokenId);
        if (!this.isUserAccountATab || this.isModal) {
            this.modalController.dismiss(null, 'deleteClient');
        }
        this.routerService.goToMainTabWithoutLogin();
    }
}
